module.exports = __webpack_public_path__ + "static/media/jordan1.b4106373.jpg";